import React from 'react'
import "./Works.scss"
import {
  BRAND_NAME,
  WORKFLOW_SUBMIT,
  WORKFLOW_SHARE_REPORTS,
  WORKFLOW_COMPARE_AND_BID,
  WORKFLOW_SECTION_SUBHEAD,
} from "../../content/landingContent"
import group from "../../../src/Assets/Group1.png"
import hfc from "../../../src/Assets/hfc2.png"
import hfcc from "../../../src/Assets/hfc1.png"
export default function Works() {
    return (
        <div className='work_background '>
                <figure className='hfc_left'><img src={hfc}alt="" /></figure>

            <div className=" container HOW_HEALBID">
                <div className="How_heal_bid_flex">
                    <div className="group_img same">
                        <figure>
                            <img src={group} alt="" />
                        </figure>
                    </div>
                    <div className="how_hilbid same">
                        <div className="para">
                            <h3>How {BRAND_NAME} <span className='wgreen'>Works</span></h3>
                        <h4>{WORKFLOW_SECTION_SUBHEAD}</h4>
                        <p>{WORKFLOW_SUBMIT}</p>
                        <p>{WORKFLOW_SHARE_REPORTS}</p>
                        <p>{WORKFLOW_COMPARE_AND_BID}</p>
                        </div>
                    </div>
                </div>
            
            </div>
                <figure className='hfc_right'> <img src={hfcc}alt="" /> </figure>
        </div>
    )
}
